export const processAddressStateForStripe = mailingAddress => {
  if (!mailingAddress) {
    return {}
  }

  return {
    line1: mailingAddress.street,
    line2: mailingAddress.streetLine2,
    city: mailingAddress.city,
    postal_code: mailingAddress.postalCode,
    state: mailingAddress.state,
  }
}

export const processStatePayloadForStripe = state => {
  const { firstName, lastName, mailingAddress, dateOfBirth } = state.application
  const dob = dateOfBirth.split('-')
  return {
    target_id: state.dasherId,
    first_name: firstName,
    last_name: lastName,
    date_of_birth: {
      year: dob[0],
      month: dob[1],
      day: dob[2],
    },
    address: processAddressStateForStripe(mailingAddress),
  }
}
